
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ad-services/schedule-callback",
      function () {
        return require("private-next-pages/ad-services/schedule-callback/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ad-services/schedule-callback"])
      });
    }
  